import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "arrow-4-corners-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinejoin: "round" },
        React.createElement("path", { strokeLinecap: "round", d: "M7.25 7.25 5 5" }),
        React.createElement("path", { fill: "currentColor", d: "M3.5 3.5V6L6 3.5z" }),
        React.createElement("path", { strokeLinecap: "round", d: "M9.75 7.25 12 5" }),
        React.createElement("path", { fill: "currentColor", d: "M13.5 3.5V6L11 3.5z" }),
        React.createElement("path", { strokeLinecap: "round", d: "M7.25 9.75 5 12" }),
        React.createElement("path", { fill: "currentColor", d: "M3.5 13.5V11L6 13.5z" }),
        React.createElement("path", { strokeLinecap: "round", d: "M9.75 9.75 12 12" }),
        React.createElement("path", { fill: "currentColor", d: "M13.5 13.5V11L11 13.5z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
